import { FIELD_TYPES } from "./fieldTypes";

export const OPTION_FIELDS = {
  clickOutParams: FIELD_TYPES.string,
  clickOutsInNewWindow: FIELD_TYPES.boolean,
  label: FIELD_TYPES.string,
  language: FIELD_TYPES.string,
  showSponsoredPositions: FIELD_TYPES.boolean,
  themeIdentifier: FIELD_TYPES.string,
  themeVariable: FIELD_TYPES.string,
  updateUrl: FIELD_TYPES.boolean
};
